import CloseIcon from "@mui/icons-material/Close";
import { Alert, Dialog, Grid, IconButton } from "@mui/material";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AccountApiService from "../../../adapters/xhr/AccountApiService";
import { MyButton } from "../../../components/my-button/MyButton";
import { MyDropdown } from "../../../components/my-dropdown/MyDropdown";
import { MyTextField } from "../../../components/my-text-field/MyTextField";
import { EmailRegExp, UserRoles, ValidPasswordRegExp, ValidTextRegExp } from "../../../Constant";

export const AddAccount = (props) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [role, setRole] = useState(null);
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [userNameValueErr, setUserNameValueErr] = useState("");
  const [roleValueErr, setRoleValueErr] = useState("");
  const [passwordValueErr, setPasswordValueErr] = useState("");
  const [emailValueErr, setEmailValueErr] = useState("");
  const UserRoleOptions = [
    { label: t("super_admin"), key: UserRoles.SuperAdmin, value: t("super_admin") },
    { label: t("system_admin"), key: UserRoles.SystemAdmin, value: t("system_admin") },
    { label: t("case_manager"), key: UserRoles.CaseManager, value: t("case_manager") },
  ];

  const submit = async () => {
    let isValid = true;
    let validEmail = new RegExp(EmailRegExp);
    if (!email.trim()) {
      setEmailValueErr("required");
      isValid = false;
    } else if (!validEmail.test(email.trim())) {
      setEmailValueErr("invalid");
      isValid = false;
    } else {
      setEmailValueErr("");
    }

    if (!role) {
      setRoleValueErr("required");
      isValid = false;
    } else {
      setRoleValueErr("");
    }

    if (!userName.trim()) {
      setUserNameValueErr("required");
      isValid = false;
    } else {
      setUserNameValueErr("");
    }

    if (!password.trim()) {
      setPasswordValueErr("required");
      isValid = false;
    } else if (password.trim().length < 10) {
      setPasswordValueErr("invalid");
      isValid = false;
    } else if (!/[a-z]/.test(password)) {
      setPasswordValueErr("invalid");
      isValid = false;
    } else if (!/[A-Z]/.test(password)) {
      setPasswordValueErr("invalid");
      isValid = false;
    } else if (!/[0-9]/.test(password)) {
      setPasswordValueErr("invalid");
      isValid = false;
    } else if (!/[!@#$%^&*]/.test(password)) {
      setPasswordValueErr("invalid");
      isValid = false;
    } else {
      setPasswordValueErr("");
    }

    if (isValid) {
      let payload = {
        email: email.trim(),
        userName: userName.trim(),
        role: role.key,
        password: password.trim(),
      };
      let response = await AccountApiService.addAccount(payload);
      if (response && response.isSuccess) {
        props.onClose(true);
      } else if (response && response.errorMessage) {
        try {
          const validationErrors = JSON.parse(response.errorMessage);
          const error = Object.keys(validationErrors)
            .map((key) => t(validationErrors[key]))
            .join(", ");
          setMessage(error);
        } catch (err) {
          setMessage("error");
        }
      } else {
        setMessage("error");
      }
    }
  };
  return (
    <Dialog fullScreen open={props.open} onClose={props.onClose}>
      <MuiDialogTitle>
        <IconButton aria-label="close" style={{ float: "right" }} onClick={(e) => props.onClose(false)}>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <Grid container justifyContent="center" className="container custom">
        <Grid item className="padding left-1 right-1">
          <h1 className="margin top-0 bottom-0">{t("add_account").toUpperCase()}</h1>
          <MyTextField label={t("username")} value={userName} regExp={ValidTextRegExp} onChange={(value) => setUserName(value.toLowerCase())} helperText={t(userNameValueErr)} />
          <MyTextField label={t("email")} value={email} onChange={(value) => setEmail(value.toLowerCase())} regExp={ValidTextRegExp} helperText={t(emailValueErr)} />
          <MyTextField label={t("password")} value={password} regExp={ValidPasswordRegExp} onChange={(value) => setPassword(value)} type="password" helperText={t(passwordValueErr)} />
          <MyDropdown options={UserRoleOptions} helperText={t(roleValueErr)} onChange={(e, value) => setRole(value)} label={t("role")} value={role} />
          <MyButton className="margin bottom-1 top-0" onClick={(e) => submit()} text={t("submit")} />
          {message && (
            <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
              {t(message)}
            </Alert>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};
